// extracted by mini-css-extract-plugin
export default {"avatarGroup":"Group_avatarGroup__iZ5yV","excessAvatarsCounter":"Group_excessAvatarsCounter__XlaDz"};